export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		life: 0,
		modifier: 0,
		strength: 0,
		dexterity: 0,
		constitution: 0,
		intelligence: 0,
		wisdom: 0,
		charisma: 0,
	},
	LIST: {
		columns: {
			id: 'ID',
			name: 'Interação',
			description: 'Descrição',
			level: 'Level',
		},
		rows: [],
	} 
}